module.exports = __webpack_public_path__ + "static/media/guiaDeEstudioFinalQuiz.dbe17957.pdf";